<template>
  <b-row>
    <b-col md=6>
      <h1>Settings<span v-if="sub">: {{sub}}</span></h1>
    </b-col>
    <b-col class="text-right">
      <slot>
        <SettingsButtons v-if="showButtons" :saving="saving" :show-save="showSave" :show-cancel="showCancel" />
      </slot>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: [
    'sub',
    'buttons',  // 'none', 'cancel' or 'both'
    'saving'
  ],
  methods: {
    clickCancel() {
      // Provide a fake event that can be prevented using Vue's @cancel.prevent syntax
      var fakeEvent = {
        doDefault: true,
        preventDefault() {
          this.doDefault = false;
        }
      };
      this.$emit('cancel', fakeEvent);
      if (fakeEvent.doDefault) this.$router.push('/dashboard/settings');
    }
  },
  computed: {
    btn() {
      // defaulted button value
      return this.buttons || (this.sub ? 'both' : 'none');
    },
    showButtons() {
      return this.btn !== 'none';
    },
    showSave() {
      return this.btn === 'both' || this.btn === 'save'
    },
    showCancel() {
      return this.btn === 'both' || this.btn === 'cancel'
    }
  }
}
</script>

<style scoped>
h1 {
  margin-top: 0;
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SettingsTitleBar.vue